//
// renderQuestionnaireAnswerItems
//
// Turn a committed questionnaire node's items + the answers given into the chat
// bubbles that show what the user picked. `author` is forwarded to MessageText only
// to drive alignment.
//
import formatPhone from '../../../../utils/phone/formatPhone';
import { Row } from '../../../display';
import { Stars } from '../../../graphics';

import { MessageText } from './components';

const renderQuestionnaireAnswerItems = (items, answers, translate, author) => {
  const nodes = [];
  if (!items) return nodes;

  items.forEach((thisItem, index) => {
    const { type, id: itemId, uniqueId } = thisItem;
    const key = uniqueId ?? `${type}_${itemId ?? index}`;
    const answer = answers?.[itemId];

    if ((type === 'checkbox') && answer) {
      nodes.push(
        <MessageText
          key={key}
          author={author}
          message={translate(itemId, 'questionnaireAnswers')}
        />,
      );
    }

    if (type === 'yesNo') {
      nodes.push(
        <MessageText
          key={key}
          author={author}
          message={(answer) ? translate(answer, 'questionnaireAnswers') : '-'}
        />,
      );
    }

    if (type === 'rating') {
      const { max } = thisItem;
      nodes.push(
        <Row
          key={key}
          gap={3}
          className="flex-wrap"
        >
          <Stars
            maxRating={max}
            rating={answer}
          />

          <p className="text-nowrap mx-auto">
            {translate(
              'cntOutOfTotal',
              undefined,
              {
                cnt: Math.round(answer * 10) / 10,
                total: max,
              },
            )}
          </p>
        </Row>,
      );
    }

    if (type === 'input') {
      let text = '-';
      if (thisItem.subType === 'phone') text = formatPhone(answer);
      else if (thisItem.subType === 'email') text = answer;
      else if (thisItem.subType === 'code') text = 'XXXXX';
      nodes.push(
        <MessageText
          key={key}
          author={author}
          message={text}
        />,
      );
    }

    if (type === 'message') {
      nodes.push(
        <MessageText
          key={key}
          author={author}
          message={answer}
        />,
      );
    }
  });

  return nodes;
};

export default renderQuestionnaireAnswerItems;
